import { AxiosError } from 'axios';
import { eventsRequest } from '../../utils/eventsRequest';
import { ErrorResponse } from '../../types';
import { OrderResponse } from '../../types';
import { SESSION_KEY_ORDER_UUID } from '../../constants';

const createOrder = async () => {
    let arrayResponse = {
        success: false,
        message: 'Failed to create order.',
        secondaryMessage: '',
        uuid: null as string | null,
    };

    try {
        const response = await eventsRequest<OrderResponse>('/orders', 'post');

        if (response.status === 200 || response.status === 201) {
            arrayResponse.success = true;
            if (response.data.data.invalidMessages && response.data.data.invalidMessages.length > 0) {
                arrayResponse.message = response.data.data.invalidMessages.join(', ');
            } else {
                arrayResponse.message = '';
            }
            if (response.data.data.cartMessages && response.data.data.cartMessages.length > 0) {
                arrayResponse.secondaryMessage = response.data.data.cartMessages.join(', ');
            } else {
                arrayResponse.secondaryMessage = '';
            }
            arrayResponse.uuid = response.data.data.order.uuid;
            localStorage.setItem(SESSION_KEY_ORDER_UUID, response.data.data.order.uuid);
        }
        return arrayResponse;
    } catch (error) {
        const axiosError = error as AxiosError<ErrorResponse>;
        if (axiosError.response && axiosError.response.status === 400) {
            arrayResponse.message = axiosError.response.data.message;
        }
        return arrayResponse;
    }
};

export default createOrder;
